import type {
  LiveMonitorAggregate,
  LiveMonitorMode,
  LiveMonitorSummaryResponse,
  LiveOpenTrade,
  LiveSessionCard,
  LiveSparklinePoint,
} from '@rhdashboard-vnext/shared';
import { apiFetch } from './client';

// ============================================================
// Live Monitor API client - Fase 4.
// Mirror de GET /api/live-monitor/summary.
//
// El backend devuelve sessions + aggregate en 1 round-trip (vs N+1 de v1).
// Detalle del shape en packages/shared/src/dto/index.ts.
// ============================================================

export type {
  LiveMonitorAggregate,
  LiveMonitorMode,
  LiveMonitorSummaryResponse,
  LiveOpenTrade,
  LiveSessionCard,
  LiveSparklinePoint,
};

export async function fetchLiveMonitorSummary(
  mode: LiveMonitorMode,
): Promise<LiveMonitorSummaryResponse> {
  return await apiFetch<LiveMonitorSummaryResponse>(
    `/api/live-monitor/summary?mode=${encodeURIComponent(mode)}`,
  );
}
